import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";

export interface Props {
    excelData: any;
}

//pipe delimited format
function NurseryNavigatorsFormatter ({excelData}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try{
        //Check for 2 sheets here
        if (!isEmpty(excelData) && excelData.Sheets.CNN !== undefined) {
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.CNN);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            const valuesIndexCollection = {
                memberSegIndex: rawCellArray.indexOf('Member Sequence') + 1,
                subscriberSSNIndex: rawCellArray.indexOf('Subscriber SSN') + 1,
                altIDIndex: rawCellArray.indexOf('Member Alternate ID') + 1,
                fnIndex: rawCellArray.indexOf('Member First Name') + 1,
                mnIndex: rawCellArray.indexOf('Member Middle Name') + 1,
                lnIndex: rawCellArray.indexOf('Member Last Name') + 1,
                planIndex: rawCellArray.indexOf('Plan ID') + 1,
                divisionIndex: rawCellArray.indexOf('Division ID') + 1,
                dobIndex: rawCellArray.indexOf('Member Date of Birth') + 1,
                subscriberIndex: rawCellArray.indexOf('Subscriber ID') + 1,
                phoneIndex: rawCellArray.indexOf('Member Home Phone') + 1,
                enrollDateIndex: rawCellArray.indexOf('Effective Date') + 1,
                disenrollDateIndex: rawCellArray.indexOf('Termination Date') + 1,
                groupIndex: rawCellArray.indexOf('Group ID') + 1,
                memberSSNIndex: rawCellArray.indexOf('Member SSN') + 1,
                planNameIndex: rawCellArray.indexOf('Plan') + 1,
                groupNameIndex: rawCellArray.indexOf('Group Name') + 1,
                memberStatusIndex: rawCellArray.indexOf('Member Active') + 1,
                tierIndex: rawCellArray.indexOf('Tier') + 1,
                relationshipTypeIndex: rawCellArray.indexOf('Relationship Type') + 1,
                deathDateIndex: rawCellArray.indexOf('Member Date of Death') + 1,
                emailIndex: rawCellArray.indexOf('Member Email Address') + 1,
                sexIndex: rawCellArray.indexOf('Member Gender') + 1,
                addIndex: rawCellArray.indexOf('Member Address') + 1,
                add2Index: rawCellArray.indexOf('Member Address 2') + 1,
                cityIndex: rawCellArray.indexOf('Member City') + 1,
                stateIndex: rawCellArray.indexOf('Member State') + 1,
                zipIndex: rawCellArray.indexOf('Member Zip Code') + 1,
                subFNIndex: rawCellArray.indexOf('Subscriber First Name') + 1,
                subLNIndex: rawCellArray.indexOf('Subscriber Last Name') + 1,
                subDOBIndex: rawCellArray.indexOf('Subscriber Date of Birth') + 1,
                subSexIndex: rawCellArray.indexOf('Subscriber Gender') + 1,
            }

            let arrayOfMemberArrays: any[] = [[
                "member_id|member_ssn|member_plan_id|plan_id|plan_name|group_id|group_name|member_coverage_start_date|member_coverage_end_date|subscriber_hire_date|" +
                "subscriber_term_date|member_coverage_status|member_coverage_type|member_dependent_code|medicare_indicator|medicaid_indicator|cob_indicator|" +
                "member_first_name|member_last_name|member_dob|member_death_date|member_death_flag|member_phone_number|member_email|member_gender|member_race|" +
                "member_address|member_address_2|member_city|member_state|member_zip_code|subscriber_id|subscriber_ssn|subscriber_plan_id|subscriber_first_name|" +
                "subscriber_last_name|subscriber_dob|subscriber_phone_number|subscriber_email|subscriber_gender|subscriber_address|subscriber_address_2|" +
                "subscriber_city|subscriber_state|subscriber_zip_code"
            ]];

            for (let i = 1; i < rowRange; i++) {
                //our member to later be pushed. Oh from what humble origins it begins
                let memberArray: any[] = [];
                let memberString: string = "";
                //for each new member array we skip over the previous members determined by the column length, removing 1 to account for our zero based index at the beginning
                let rowMultiplier = columnRange * i - 1;

                let today = new Date();

                let termDate = new Date(Math.round((rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)] - 25568)*86400*1000));

                //remove terms
                if (termDate > today) {

                    //member ID
                    if (valuesIndexCollection.memberSegIndex > 0 && valuesIndexCollection.subscriberIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString() +
                            rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.memberSSNIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.memberSSNIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.planIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.planIndex)].toString().toUpperCase() + "|");
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.planIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.planNameIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.planNameIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.groupIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.groupIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.groupNameIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.groupNameIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.enrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.enrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    //removes 12/31/2222 dates
                    if (valuesIndexCollection.disenrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }else if (date === "117974") {
                            date = "";
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    memberString += "||";

                    //check if COBRA or active
                    if (valuesIndexCollection.memberStatusIndex > 0 && valuesIndexCollection.divisionIndex > 0) {
                        if(rawCellArray[(rowMultiplier + valuesIndexCollection.divisionIndex)].toString().substring(6,7) === "9"){
                            memberString += "Cobra|";
                        }
                        else if (rawCellArray[(rowMultiplier + valuesIndexCollection.memberStatusIndex)].toString() === "Y"){
                            memberString += "Active|";
                        }
                        else {
                            memberString += "Terminated|";
                        }
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.tierIndex > 0) {
                        if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "EM"){
                            memberString += "Employee|";
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "ES"){
                            memberString += "Employee + Spouse|";
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "EC"){
                            memberString += "Employee + Children|";
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "FA"){
                            memberString += "Family|";
                        }
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.relationshipTypeIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.relationshipTypeIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    memberString += "|||";

                    if (valuesIndexCollection.fnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.fnIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.lnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.lnIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.dobIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.dobIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.deathDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.deathDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.deathDateIndex > 0) {
                        if(rawCellArray[(rowMultiplier + valuesIndexCollection.deathDateIndex)].toString().length > 0){
                            memberString += "Deceased|";
                        }
                        else {
                            memberString += "|";
                        }
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.phoneIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.phoneIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.emailIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.emailIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.sexIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.sexIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    memberString += "|";

                    if (valuesIndexCollection.addIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.addIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.add2Index > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.add2Index)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.cityIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.cityIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.stateIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.stateIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.zipIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.zipIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.subscriberIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.subscriberSSNIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.planIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.planIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.subFNIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subFNIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.subLNIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subLNIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.subDOBIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.subDOBIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.phoneIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.phoneIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.emailIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.emailIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    //subscriber info
                    if (valuesIndexCollection.subSexIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subSexIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.addIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.addIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.add2Index > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.add2Index)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.cityIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.cityIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.stateIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.stateIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.zipIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.zipIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    memberArray.push(memberString);

                    arrayOfMemberArrays.push(memberArray);
                }
            }

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            const today = new Date();

            const month = today.getMonth() + 1;

            let monthString = "";

            let dayString = "";

            if(month < 10){
                monthString = "0" + month.toString();
            }
            else{
                monthString = month.toString();
            }

            const day = today.getDate();

            if(day < 10) {
                dayString = "0" + day.toString();
            }
            else {
                dayString = day.toString();
            }

            const year = today.getFullYear();

            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "CAS_CNN_ELIG" + monthString + dayString + year);
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("CAS_CNN_ELIG" + monthString + dayString + year)) {
                if (!eligWorkbook.Props) eligWorkbook.Props = {};

                //setting the workbook title through props
                eligWorkbook.Props.Title = "CAS_CNN_ELIG" + monthString + dayString + year + ".txt";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "CAS_CNN_ELIG" + monthString + dayString + year + ".txt", {});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            } else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.CNN = undefined;
        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.CNN = undefined;

    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                File Download Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
        </div>
    );
}


export default React.memo(NurseryNavigatorsFormatter)

NurseryNavigatorsFormatter.propTypes = {
    excelData: PropTypes.object.isRequired,
};